import { render, staticRenderFns } from "./knowledgeTwo.vue?vue&type=template&id=6b17bb0e&scoped=true&"
import script from "./knowledgeTwo.vue?vue&type=script&lang=js&"
export * from "./knowledgeTwo.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeTwo.vue?vue&type=style&index=0&id=6b17bb0e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b17bb0e",
  null
  
)

export default component.exports